import type { ReactNode } from 'react';

export const symbol_settings_remote: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M358-40q-16 0-27-11t-11-27v-484q0-16 11-27t27-11h244q16 0 27 11t11 27v484q0 16-11 27t-27 11H358Zm122-358q17 0 29.5-12.5T522-440q0-18-12-31t-30-13q-18 0-31 13t-13 31q0 18 13 30t31 12Zm0-342q-36 0-70 11.5T347-695q-10 8-22.5 7.5T303-697q-9-9-8.5-21.5T305-739q38-30 82.5-45.5T480-800q48 0 92.5 15.5T655-739q10 8 10.5 20.5T657-697q-9 9-21.5 9.5T613-695q-29-22-63-33.5T480-740Zm0-160q-68 0-130.5 23T235-811q-11 8-24 8.5t-22-8.5q-9-9-8.5-21.5T191-853q61-51 135-79t154-28q80 0 153.5 27.5T767-852q10 8 10.5 21t-8.5 22q-9 9-22 8t-24-10q-51-44-113.5-66.5T480-900ZM380-100h200v-440H380v440Zm0 0h200-200Z"
		/>
	</svg>
);
